import { Injectable } from '@angular/core';
import { produce } from 'immer';
import { map, Observable } from 'rxjs';

import { CanvasElement } from '@blaze-runtime/engine-domain';
import { getActiveBinding } from '@blaze-shared/elements-domain';

import { hasDataProps } from '../../canvas-elements/element-model/element-props-guards';
import { BaseChildrenHandlerService } from '../../canvas-elements/io-data/default-handlers/base-children-handler.service';
import {
  ComponentChildrenConfig,
  ComponentChildrenHandler,
} from '../../canvas-elements/io-data/io-data.models';
import {
  DataFilterRenderElementInstance,
  InputsCache,
} from '../../canvas-elements/models/render-element.models';

@Injectable({ providedIn: 'root' })
export class DataFilterChildrenHandlerService
  extends BaseChildrenHandlerService
  implements ComponentChildrenHandler
{
  buildInputsCache(element: CanvasElement): InputsCache {
    const filterWorkflowId = hasDataProps(element)
      ? getActiveBinding(element.props.data)?.dataSource?.id
      : undefined;
    const inputsCache = this.runtimeFacade.getWorkflowInputsToElementsMap(filterWorkflowId) || {};
    return inputsCache;
  }

  connectChildren({
    childrenUpdates$,
    inputsCache,
    formInstance,
  }: ComponentChildrenConfig): Observable<void> {
    const instance = formInstance as unknown as DataFilterRenderElementInstance;

    return childrenUpdates$.pipe(
      map(({ event }) => {
        const modelField = inputsCache[event.elementId];
        // field not found in model
        if (typeof modelField === 'boolean') {
          return;
        }
        // when changing filter input type, the new element sends an update before data-filter schema updates
        if (!instance.schema?.columns.find((c) => c.name === modelField)) {
          return;
        }

        instance.data = produce(instance.data ?? {}, (draft: any) => {
          let value = event.data;
          if (typeof value === 'string' && !value) {
            value = null;
          }
          draft[modelField] = value;
        });
        instance.dataUpdated();
      }),
    );
  }
}
